import { CheckCircle2, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WHY_POINTS, PROCESS_STEPS } from "@/data/content";

const WhyIqmize = () => (
  <section id="why" data-testid="why-section" className="py-20 lg:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
        <div>
          <SectionHeading
            eyebrow="Why IQMIZE?"
            title="Studying harder does not always mean learning better."
            description="Students often spend hours reading, attending tuition classes and revising — yet struggle to recall information when they need it. IQMIZE introduces a structured approach that encourages students to:"
          />
          <div className="mt-8 space-y-4">
            {WHY_POINTS.map((point, i) => (
              <Reveal key={point} delay={i * 0.08} className="flex items-start gap-3.5">
                <CheckCircle2 size={22} className="mt-0.5 shrink-0 text-brand" strokeWidth={2} />
                <p className="text-base md:text-lg font-semibold text-slate-800">{point}</p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.4} className="mt-9 text-sm uppercase tracking-[0.2em] font-bold text-brand">
            Learn → Think → Grow → Achieve
          </Reveal>
        </div>

        <Reveal delay={0.15} className="lg:pt-10">
          <div className="rounded-3xl border border-slate-200 bg-brand-light p-8 lg:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <p className="text-sm uppercase tracking-[0.2em] font-bold text-brand">What makes IQMIZE different?</p>
            <h3 className="mt-4 text-2xl font-semibold tracking-tight text-slate-900">
              It's not how many hours a student studies. It's how the student studies.
            </h3>
            <p className="mt-4 text-base leading-relaxed text-slate-600">
              Students are encouraged to develop a repeatable learning process — and gradually become more
              independent learners.
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-y-3 gap-x-2" data-testid="process-chain">
              {PROCESS_STEPS.map((step, i) => (
                <span key={step} className="flex items-center gap-2">
                  <span className="rounded-full bg-white border border-slate-200 px-4 py-1.5 text-sm font-bold text-inavy shadow-sm">
                    {step}
                  </span>
                  {i < PROCESS_STEPS.length - 1 && <ArrowRight size={14} className="text-brand shrink-0" />}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhyIqmize;
